import React from "react";
import { Card } from ".";
import { FontSize } from "../../Constants/Enums/Size.enums";
import { Colors } from "../../Constants/colors";

interface DataInfo {
  image: string;
  title: string;
  value: string;
  color: string;
}
interface Props {
  data: DataInfo[];
}
export const SmallCardLists = ({ data }: Props) => {
  const totalGridCol = data.length;
  return (
    <div
      className={`flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${totalGridCol} justify-around gap-8`}
    >
      {data.map(({ image, title, value, color }) => {
        return (
          <Card>
            <div className="flex gap-6">
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <img
                  src={image}
                  alt="students-icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    color: color,
                    position: "absolute",
                  }}
                />
                <div
                  style={{
                    backgroundColor: color,
                    width: "100%",
                    height: "100%",
                    opacity: 0.1,
                    position: "absolute",
                  }}
                />
              </div>
              <div className="flex flex-col text-right">
                <p
                  style={{
                    color: Colors.DarkGrey,
                  }}
                >
                  {title}
                </p>
                <p
                  style={{
                    fontSize: FontSize.F28,
                    color: Colors.Black,
                  }}
                >
                  {value}
                </p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
